import { Flow } from 'signup-constants/Flow';
import { getFlowConfig, getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isPostVerification } from '../../flow-settings/settingsSelectors';
import { isTransitionAndAnimationsDisabled } from '../../selenium/seleniumFeatures';
import { Data } from '../../signup-data/DATA';
import { GSWHIndustry, Industry } from '../../signup-data/IndusrtyOption';
import { getExistingUserStep } from '../../step-existing-user/existingUserUtils';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { getParameter } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getCurrentStep } from '../../store/flow/selectors';
import { setSignupDataValue } from '../../store/signup-data/action-creators';
import { Tracker } from '../../store/tracking/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { isFlow } from '../../utils/isFlow';
import { Step } from '../../views/Step';
import { ExperimentKeys } from '../ExperimentKeys';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
export const shouldUseAnimationsGSWH = state => {
  const currentStep = getCurrentStep(state);
  return currentStep === Step.HubOption && !getIsMobile() && !isTransitionAndAnimationsDisabled();
};
export const industryCollectionMethod = industryInput => {
  return industryInput ? 'input' : 'button';
};
export const gswhExistingUserPreVerificationSteps = [Step.LandingPage, Step.CodeVerification];
export const gswhExistingUserVariantBPostVerificationSteps = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
const gswhVariantAPostVerificationSteps = [Step.Password, Step.Name, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubOption, Step.BusinessGoals, Step.AhaMoment, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
export const getGSWHVariantAPostVerificationSteps = () => {
  let steps = gswhVariantAPostVerificationSteps;

  if (!getIsMobile() && !isFlow(Flow.Crm)) {
    steps = NextStepManager.removeSteps(Step.HubOption)(steps);
  }

  return steps;
};
export const preFillHubInterestGSWH = dispatch => {
  if (!getIsMobile()) {
    dispatch(setSignupDataValue(Data.HubOption, getFlowConfig().hubInterest));
    dispatch(setSignupDataValue(Data.HubInterest, getFlowConfig().hubInterest));
  }
};
export const setupAuthForOAuthExistingUserGSWH = (state, experimentKey, dispatch) => {
  const preVerification = gswhExistingUserPreVerificationSteps;
  let postVerification;
  const parameter = getParameter(state, experimentKey);
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-${parameter}`));

  if (parameter === ExperimentParameterGroup.Variant_A) {
    postVerification = getGSWHVariantAPostVerificationSteps();
  } else if (parameter === ExperimentParameterGroup.Variant_B) {
    postVerification = gswhExistingUserVariantBPostVerificationSteps;
  }

  let nextSteps = [...preVerification, ...postVerification];

  if (getIsAuthenticated(state) && !isPostVerification()) {
    nextSteps = NextStepManager.pushNextSteps(getExistingUserStep())(nextSteps);
  }

  dispatch(setFlow(nextSteps, preVerification, postVerification, [], getFlowSteps().postExistingAccountSelection));
};
export const gswhIndustryToIndustryMapping = {
  [GSWHIndustry.TechnologyAndServices]: Industry.TechnologyAndServices,
  [GSWHIndustry.Education]: Industry.Education,
  [GSWHIndustry.Consulting]: Industry.Consulting
};
export const isInACQ140VariantACRM = state => {
  const isInVariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140, [ExperimentParameterGroup.Variant_A]);
  return isInVariantA && isFlow(Flow.Crm) && !getIsMobile();
};
export const isInACQ140VariantBCRM = state => {
  const isInVariantB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140, [ExperimentParameterGroup.Variant_B]);
  return isInVariantB && isFlow(Flow.Crm) && !getIsMobile();
};
export const isInACQ140VariantsCRM = state => {
  const isInVariantAorB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  return isInVariantAorB && isFlow(Flow.Crm) && !getIsMobile();
};
export const isInACQ142VariantACRM = state => {
  const isInVariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A]);
  return isInVariantA && isFlow(Flow.Crm);
};
export const isInACQ142VariantAMSS = state => {
  const isInVariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A]);
  return isInVariantA && !isFlow(Flow.Crm);
};
export const isInACQ142VariantBCRM = state => {
  const isInVariantB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_B]);
  return isInVariantB && isFlow(Flow.Crm);
};